import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'app/client-core/api.service';
import { CommunicationRequestCommentDto, RequestMessage } from 'app/client-core/dtos/communication-request.model';
import { ProgramService } from 'app/client-core/services/program.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { DropzoneComponent } from 'ngx-dropzone-wrapper';

const $ = jQuery;

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {
  @ViewChild('dropzone') dropzoneNewMessage: DropzoneComponent;
  @Input() message: RequestMessage;
  @Input() parent: RequestMessage;
  @Input() versionId: number;
  @Input() requestId: number;
  @Input() showReply: boolean;
  @Input() showCommentsControl: boolean;
  @Input() programId: number;

  replyMessage: string;
  replyOpened: boolean;
  sendEmail: number = 1;
  editing: boolean;
  action = "Create";
  config: any;
  files: File[] = [];
  saving: boolean;

  constructor(
    private programService: ProgramService,
    private notificationService: NotificationService,
    private zone: NgZone,
    private apiService: ApiService
  ) {
    const self = this;
    this.config = {
      autoProcessQueue: false,
      acceptedFiles: '*',
      uploadMultiple: true,
      addRemoveLinks: true,
      dictDefaultMessage: 'Click or drop files here',
      init: function() {
        var drop = this;
        this.on('addedfile', function(file) {
          self.zone.run(() => {
            console.log(file);
            self.files.push(file);
            console.log(self.files);
          })
        });

        this.on('removedfile', function(file) {
          self.zone.run(() => {
            self.files = drop.files;
            console.log(self.files);
          })
        });
      }
    };
  }

  ngOnInit() {
  }

  saveComment() {
    this.saving = true;
    this.programService.addCommunicationRequestComment({
      action: this.action,
      versionId: this.versionId,
      requestId: this.requestId,
      message: this.replyMessage,
      parentId: this.message.requestMessageId,
      sendEmail: this.sendEmail,
      requestMessageId: this.message.requestMessageId,
      fileNames: (this.files || []).map(f => f.name).join(',')
    } as CommunicationRequestCommentDto).subscribe(res => {
      if (this.files && this.files.length) {
        let promisses = [];
        this.files.forEach(file => {
          promisses.push(this.uploadFile(file, this.requestId, this.versionId, res.data));
        });
        Promise.all(promisses).then(filesRes => {
          this.dropzoneNewMessage.directiveRef.reset();
          this.cancel();
          this.reloadMessagesAfterSave();
        }); 
      } else {
        this.cancel();
        this.reloadMessagesAfterSave();
      }
    });
  }

  reloadMessagesAfterSave() {
    setTimeout(() => {
      this.saving = false;
      this.programService.reloadCommunicationMessages.next();
    }, 1000);
  }


  cancel() {
    this.replyMessage = "";
    this.action = "Create";
    this.replyOpened = false;
    this.editing = false;
    this.files = [];
  }

  edit() {
    this.cancel();
    this.action = "Edit";
    this.replyMessage = this.message.message;
    this.replyOpened = true;
    this.editing = true;
  }

  deleteMessage() {
    this.action = "Delete";
    this.notificationService.smartMessageBox({
      title: "Delete Message",
      content: "Are you sure you would like to delete this message? This will delete the message you have selected and all replies.",
      buttons: '[Cancel][Delete]'

    }, (ButtonPressed, Value) => {
      if (ButtonPressed == "Delete") {
        this.saveComment();
      } else {
        this.action = "Create";
      }
    });
  }

  openReply() {
    this.cancel();
    this.replyOpened = !this.replyOpened;
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  startUploadClick(componentId) {
    $('#' + componentId + ' .dz-clickable').trigger('click');
  }

  uploadFile(file, id, versionId, messageId) {
    return this.apiService.uploadCommunicationRequestMessageFile(file, this.programId, id, messageId, versionId);
  }

  downloadFile(key) {
    this.programService.getCommunicationFile(key);
  }

  removeFiles() {
    this.dropzoneNewMessage.directiveRef.reset();
    this.files = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/chat-message/chat-message.component.ts